export const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_GRADEBOOK':
      return {
        ...state,
        gradebook: action.payload,
      }
    case 'UPDATE_ISCANVASCOURSE':
      return {
        ...state,
        isCanvasCourse: action.payload,
      }
    case 'UPDATE_SECTIONS':
      return {
        ...state,
        sections: action.payload,
      }
    case 'UPDATE_SELECTED_SECTIONS':
      return {
        ...state,
        selectedSections: action.payload,
      }
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload,
        loading: true,
      }
    case 'RESTORE_PAGE':
      return {
        ...state,
        page: action.payload,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      }
    case 'UPDATE_FILTERS':
      return {
        ...state,
        filters: action.payload,
      }
    case 'UPDATE_SCORE_FORMAT':
      return {
        ...state,
        isPercentFormat: action.payload,
      }
    case 'UPDATE_MODAL':
      return {
        ...state,
        modal: {
          ...state.modal,
          ...action.payload,
        },
      }
    default:
      return state
  }
}
